import * as types from './constants';

// Get Billing Overview Info
export const getBillingOverviewInfoRequest = data => (
  { type: types.GET_BILLING_OVERVIEW_INFO_REQUEST, payload: data }
);

export const getBillingOverviewInfoDone = data => (
  { type: types.GET_BILLING_OVERVIEW_INFO_DONE, payload: data }
);

export const getBillingOverviewInfoFailed = errors => (
  { type: types.GET_BILLING_OVERVIEW_INFO_FAILED, payload: errors }
);